import { Button, Col, Descriptions, Row, Space, Tabs } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Image } from 'antd';

import { WorkRecord } from '../../modules/work-records';
import TabPane from 'antd/lib/tabs/TabPane';
import { useEffect, useState } from 'react';
import AttachedFileListComponent from '../tasks/AttachedFileListComponent';
import { maskingRrn, priceToString } from '../../util/utils';

interface WorkRecordDetailComponentProps {
  workRecord: WorkRecord;
  // openDrawer(key: string): void;
  downloadFile: (attachFileId: string, fileName: string) => void;
  moveToEditPage(): void;
  moveToPrintPage(): void;
}

function WorkRecordDetailComponent({
  workRecord,
  // openDrawer,
  downloadFile,
  moveToEditPage,
  moveToPrintPage,
}: WorkRecordDetailComponentProps) {
  console.log(workRecord);
  const [mount, setMount] = useState(true);
  const [imageList, setImageList] = useState<any>();
  const [visible, setVisible] = useState(false);
  const [imageData, setImageData] = useState<any>();

  useEffect(() => {
    if (!mount) return;
    let children: any = [];
    for (const _file of workRecord.file) {
      children.push(<Image width={200} src={_file.url} key={_file.id} />);
    }
    setImageList(children);

    return () => setMount(false);
  }, [workRecord, mount]);

  const workerData =
    workRecord.data.workers === undefined
      ? null
      : workRecord.data.workers.map((value: any, index: number) => (
          <li key={index} style={{ listStyleType: 'none' }}>
            {value.gongjong} | {value.name ?? '-'} | {value.jigjong ?? '-'} |{' '}
            {value.numOfWorkers}명 | {value.numOfGongsu}공수
          </li>
        ));

  const directWorkerData =
    workRecord.data.directWorkers === undefined
      ? null
      : workRecord.data.directWorkers.map((value: any, index: number) => (
          <li key={index} style={{ listStyleType: 'none' }}>
            {value.name.split('|')[0].trim()} |{' '}
            {maskingRrn(value.name.split('|')[1].trim())} |{' '}
            {value.gongjong ?? '-'} | {value.jigjong ?? '-'} |{' '}
            {priceToString(value.price)} | {value.numOfGongsu}공수
          </li>
        ));

  const openImagePreview = (file: any) => {
    setImageData(file);
    setVisible(true);
  };

  // const items: MenuProps['items'] = [
  //   {
  //     key: '1',
  //     label: '수정',
  //   },
  //   {
  //     key: '2',
  //     label: '삭제',
  //   },
  // ];

  // const handleMenuClick: MenuProps['onClick'] = (e) => {
  //   console.log('click', e);
  //   openDrawer(e.key);
  // };

  return (
    <>
      <Row justify="space-between">
        <Col>
          <Title level={3}>작업일보 상세</Title>
        </Col>
        <Col>
          <Space>
            <Button size="small" onClick={() => moveToEditPage()}>
              수정
            </Button>
            <Button size="small" onClick={() => moveToPrintPage()}>
              프린트
            </Button>
          </Space>
          {/* <Dropdown.Button
            menu={{ items, onClick: handleMenuClick }}
            placement="bottom"
            arrow
            size="small"
            // style={{ marginRight: '70px' }}
          >
            더보기
          </Dropdown.Button> */}
        </Col>
      </Row>
      <Tabs destroyInactiveTabPane>
        <TabPane tab="작업내용" key="1">
          <Row>
            <Col span={24}>
              <Descriptions bordered column={1} size="small">
                <Descriptions.Item label="날짜">
                  {workRecord.createdDate}
                </Descriptions.Item>
                <Descriptions.Item label="작성자">
                  {workRecord.createdBy ? workRecord.createdBy.name : ''}
                </Descriptions.Item>
                <Descriptions.Item
                  label="금일 작업내용"
                  style={{ whiteSpace: 'pre-wrap' }}
                >
                  {workRecord.todayNote}
                </Descriptions.Item>
                <Descriptions.Item
                  label="명일 예정사항"
                  style={{ whiteSpace: 'pre-wrap' }}
                >
                  {workRecord.tomorrowNote}
                </Descriptions.Item>
                <Descriptions.Item
                  label="특이사항"
                  style={{ whiteSpace: 'pre-wrap' }}
                >
                  {workRecord.issueNote}
                </Descriptions.Item>
                <Descriptions.Item label="외주공사 인력투입현황">
                  {workerData}
                </Descriptions.Item>
                <Descriptions.Item label="직영공사 출역현황">
                  {directWorkerData}
                </Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>
          <div style={{ marginTop: '30px' }}>
            <AttachedFileListComponent
              attachedFiles={workRecord.file}
              downloadFile={downloadFile}
              openImagePreview={openImagePreview}
            />
          </div>
          {imageData && (
            <Image
              width={200}
              style={{ display: 'none' }}
              preview={{
                visible,
                src: imageData?.url,
                onVisibleChange: (value) => {
                  setVisible(value);
                  setImageData(null);
                },
              }}
            />
          )}
        </TabPane>
        <TabPane tab="현장사진" key="2">
          {workRecord.file.length !== 0 ? (
            <Image.PreviewGroup>{imageList}</Image.PreviewGroup>
          ) : (
            <>
              <Row justify={'center'} style={{ marginTop: '100px' }}>
                <Col>
                  <Title level={5}>현장사진이 존재하지 않습니다.</Title>
                </Col>
              </Row>
            </>
          )}
        </TabPane>
      </Tabs>
    </>
  );
}

export default WorkRecordDetailComponent;
